export const formatCurrency = (value) => {
  if (value === undefined || value === null || isNaN(value)) return '0.00';
  return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const isIntakeImageFile = (file) => {
  if (!file) return false;
  const name = typeof file === 'string' ? file : (file.filename || file.name || '');
  return /\.(jpg|jpeg|png|gif|webp|bmp|heic|heif)$/i.test(name);
};

/**
 * Fetch an authenticated PDF from the backend and open it in a new tab.
 * Uses axios to include the auth header, then creates a blob URL.
 */
export const openAuthenticatedPdf = async (url) => {
  const axios = (await import('axios')).default;
  try {
    const response = await axios.get(url, { responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
    // Clean up blob URL after a delay to allow the tab to load
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  } catch (err) {
    console.error('Error opening PDF:', err);
    alert('Unable to generate PDF. Please try again.');
  }
};
